<template lang="pug">
.StatisticLivingPlacePanel(v-if="estadisticas")
  div(v-show="chartData && chartData.length")
    GChart.BarChart(
      type="BarChart"
      :data="chartData"
      :options="chartOptions"
      @ready="onChartReady"
    )
  div(v-show="!chartData || !chartData.length")
    md-progress-spinner(md-mode="indeterminate")
</template>

<script>
import { GChart } from 'vue-google-charts'
import { grayColor } from '@/theme.js'
import colorPropertyMixin from '@/mixins/color-property.js'

export default {
  name: 'StatisticLivingPlacePanel',
  mixins: [colorPropertyMixin],
  components: {
    GChart
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    estadisticas: Object
  },
  mounted () {
    this.updateData()
  },
  data () {
    return {
      stylePositions: 3,
      chartData: [],
      chartOptions: {
        height: 120,
        bars: 'horizontal',
        bar: { groupWidth: '60%' },
        chartArea: { width: '40%', left: '0', top: 1, bottom: 1 },
        legend: { position: 'none' },
        annotations: {
          textStyle: {
            fontName: 'Times-Roman',
            fontSize: 18,
            color: grayColor
          },
          highContrast: false
        },
        axes: {
          y: {
            0: { side: 'right' }
          }
        },
        hAxis: {
          textStyle: {
            color: 'white',
            fontSize: 1
          }
        },
        colors: [ grayColor ]
      }
    }
  },
  methods: {
    onChartReady (chart, google) {
      const data = google.visualization.arrayToDataTable(this.chartData)
      const view = new google.visualization.DataView(data)
      view.setColumns(
        [
          0,
          1,
          { calc: 'stringify', sourceColumn: 1, type: 'string', role: 'annotation' },
          2
        ]
      )
      chart.draw(view, this.chartOptions)
    },
    updateData () {
      setTimeout(_ => {
        this.chartData = [
          [ '', '', { role: 'annotation' } ],
          [ '', this.formatNumber(this.estadisticas.propia), `Es propia ${this.format(this.estadisticas.propia)}%` ],
          [ '', this.formatNumber(this.estadisticas.alquilada), `Es alquilada ${this.format(this.estadisticas.alquilada)}%` ],
          [ '', this.formatNumber(this.estadisticas.prestada), `Es prestada, la cuidan ${this.format(this.estadisticas.prestada)}%` ],
          [ '', this.formatNumber(this.estadisticas.noInformado), `No informado ${this.format(this.estadisticas.noInformado)}%` ]
        ]
      }, 1000)
    },
    format (value) {
      return value > 0 ? value : '-'
    },
    formatNumber (value) {
      return value < 0 ? 0 : value
    }
  },
  watch: {
    estadisticas () {
      this.updateData()
    }
  }
}
</script>

<style scoped lang="stylus">
.BarChart >>>
  svg
    g
      g
        g
          rect[width="1"][stroke="none"][stroke-width="0"][fill="#cccccc"],
          rect[width="1"][stroke="none"][stroke-width="0"][fill="#333333"]
            display: none
        g
          text[text-anchor="middle"][stroke="none"][stroke-width="0"],
          text[text-anchor="end"][stroke="none"][stroke-width="0"][transform]
            display: none
</style>
